export default __webpack_public_path__ + "static/media/pde-icona.c8c39395.png";